module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('problem-search', {
    ref: "s",
    on: {
      "search": _vm.getPagedProblem
    }
  }), _vm._v(" "), _c('problem-table', {
    attrs: {
      "tableData": _vm.problemList
    }
  }), _vm._v(" "), _c('el-pagination', {
    attrs: {
      "current-page": _vm.pageIndex,
      "page-sizes": [20, 30, 40, 50],
      "page-size": _vm.rows,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "size-change": _vm.pageSizeChange,
      "current-change": _vm.pageIndexChange
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ctitle"
  }, [_c('h2', [_vm._v("正式题目列表")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3f03917f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/problemList.vue
// module id = 642
// module chunks = 2